import React from 'react'
import HomeBlog from '../home/HomeBlog'

const OurVehicles = () => {
  return (
    <>
    
      <HomeBlog />

    </>
  )
}

export default OurVehicles